export default __webpack_public_path__ + "static/media/market-opinion.2a8b409f.png";